import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Driver, driver } from 'driver.js';
import { tap } from 'rxjs';
import { SavedAuditsResult } from 'src/app/core-module/models/Audits/saved-audits-result';
import { ActionListRequest } from 'src/app/core-module/models/Compliance-Actions/action-list-request';
import { ActionResult } from 'src/app/core-module/models/Compliance-Actions/action-result';
import { UserLocationSave } from 'src/app/core-module/models/user-location-save';
import { UserLocation } from 'src/app/core-module/models/UserManagement/user-location';
import { Toastr } from 'src/app/core-module/models/Utils/toastr';
import { AuditService } from 'src/app/core-module/services/audit.service';
import { AuditValidationService } from 'src/app/core-module/services/audits/audit-validation.service';
import { AuthService } from 'src/app/core-module/services/auth.service';
import { ComplianceActionService } from 'src/app/core-module/services/compliance-action.service';
import { LocalStorageService } from 'src/app/core-module/services/local-storage.service';
import { ToastrService } from 'src/app/core-module/services/toastr.service';
import { UtilService } from 'src/app/core-module/services/util.service';
import { CustomerContextService } from 'src/app/core-module/services/customer-context.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HomeComponent {
  private readonly customerContext = inject(CustomerContextService);
  constructor(private localStorage: LocalStorageService, private userService: AuthService, private auditService: AuditService, private router: Router, public util: UtilService, public auditValidation: AuditValidationService, public actionService: ComplianceActionService, public toastr: ToastrService) {


  }

  private readonly homeTourSeenKey = 'homeTourSeen';
  private readonly homeTourSeenMobileKey = 'homeTourSeenMobile';
  private readonly enableHomeTour = false;
  private homeTour: Driver | null = null;

  localAuditList: UserLocationSave[] = [];
  cloudAuditList: UserLocationSave[] = [];
  public auditList: UserLocationSave[] = [];



  actionList: ActionResult = new ActionResult();
  username: string = '';

  public auditsReady: boolean = false;
  public showActionList: boolean = true;
  public showCurrentAudits: boolean = true;

  public actionWaiting: boolean = true;

  ngOnInit() {
    this.setFirstGUIDs()
    this.getUserData();
    this.auditService.reconcileLocalAudits().pipe(
      tap(removedGUIDs => {
        this.showReconciliationMessage(removedGUIDs.length);
        this.getLocalData();
        this.fetchCentralAudits();
      })
    ).subscribe();
    this.getActionData();
    setTimeout(() => this.startHomeTourIfNeeded(), 0);

  }

  private showReconciliationMessage(removedCount: number) {
    if (removedCount === 0) {
      return;
    }

    const auditText = removedCount === 1 ? 'audit was' : 'audits were';
    this.toastr.addToastr(new Toastr({
      Type: 2,
      Message: `${removedCount} locally saved ${auditText} removed because they are no longer active.`
    }));
  }

  setFirstGUIDs() {
    this.auditService.setLocalAuditGUIDs();
  }


  fetchCentralAudits() {
    this.auditsReady = false;
    this.auditService.centralAudits().pipe(tap(res => {
      this.cloudAuditList = res;
      this.combineAudits();

    })).subscribe();
  }
  combineAudits() {
    this.cloudAuditList.forEach(e => {
      var localAudit = this.auditList.find(f => f.AuditGUID == e.AuditGUID);
      if (localAudit == undefined) {
        this.auditList.push(new UserLocationSave(e));
        return;
      }

      var graceMinutes: number = 1;
      var testDate = new Date(new Date(localAudit!.LastUpdate).getTime() + graceMinutes * 60000);
      if (new Date(e.LastUpdate) > testDate) {
        this.auditList.splice(this.auditList.findIndex(f => f.AuditGUID == e.AuditGUID), 1, new UserLocationSave(e));
      }
    })
    this.auditList.sort((a, b) => {
      if (a.FlattenedQuestions[0].AuditCompletionInfo.StartedDate > b.FlattenedQuestions[0].AuditCompletionInfo.StartedDate) {
        return 1;
      }
      if (a.FlattenedQuestions[0].AuditCompletionInfo.StartedDate < b.FlattenedQuestions[0].AuditCompletionInfo.StartedDate) {
        return -1;
      }
      return 0;
    })


    this.auditsReady = true;
  }
  /*tempCleanAuditFunction(incomingData: UserLocationSave[]) {
    console.log(incomingData)
    var replaceList: UserLocationSave[] = [];
    incomingData.forEach(e => {
      replaceList.push(new UserLocationSave(e));
    });
    this.tempAuditList = replaceList;
  }*/

  getUserData() {
    this.userService.getUserName()
      .pipe(
        tap((a: any) => {
          this.username = a.Username;
        })
      )
      .subscribe();
    if (this.username == null) {
      return;
    }
  }
  getLocalData() {
    this.localAuditList = [];
    this.auditList = [];
    this.auditService.getLocalAudits()
      .pipe(
        tap((a: UserLocationSave[]) => {
          a.forEach(e => {
            this.localAuditList.push(new UserLocationSave(e));
            this.auditList.push(new UserLocationSave(e));
          });
        })
      )
      .subscribe();
  }
  refreshAudits() {
    this.getLocalData();
    this.fetchCentralAudits();
  }
  refreshActionData() {
    this.getActionData();
  }
  getActionData() {
    var request = new ActionListRequest();
    request.DashboardRequest = true;
    this.actionService.getCurrentActions(request).pipe(
      tap((res: ActionResult) => {

        if (res.IsError) {
        } else {
          this.actionList = res;
          this.orderActionList();
        }
        this.actionWaiting = false;
      })
    ).subscribe();
  }

  changeViewActionList() {
    this.showActionList = !this.showActionList;
  }
  changeViewAuditsList() {
    this.showCurrentAudits = !this.showCurrentAudits;
  }
  orderActionList() {
    this.actionList.Actions = this.actionList.Actions.sort((a, b) => { return <any>new Date(a.ActionDeadline) - <any>new Date(b.ActionDeadline) });
  }
  linkedAudit(auditGUID: string, isCloudSave: boolean): UserLocationSave {
    if (!isCloudSave) {
      return new UserLocationSave();
    }
    if (this.localAuditList.findIndex(f => f.AuditGUID == auditGUID) != -1) {
      return this.localAuditList.find(f => f.AuditGUID == auditGUID)!;
    }
    return new UserLocationSave();
  }

  private startHomeTourIfNeeded() {
    if (!this.enableHomeTour) {
      return;
    }
    if (typeof window === 'undefined') {
      return;
    }
    if (window.innerWidth < 1024) {
      this.startMobileHomeTourIfNeeded();
      return;
    }
    if (window.localStorage.getItem(this.homeTourSeenKey) === 'true') {
      return;
    }
    if (!document.querySelector('#pnlMenu')) {
      return;
    }

    this.homeTour = this.buildHomeTour();
    this.homeTour.drive();
  }

  private startMobileHomeTourIfNeeded() {
    if (typeof window === 'undefined') {
      return;
    }
    if (window.localStorage.getItem(this.homeTourSeenMobileKey) === 'true') {
      return;
    }
    if (!document.querySelector('#btnMobileMenu')) {
      return;
    }

    this.homeTour = this.buildMobileHomeTour();
    this.homeTour.drive();
  }

  private buildHomeTour(): Driver {
    const tour = driver({
      showProgress: true,
      allowClose: false,
      overlayClickBehavior: 'nextStep',
      showButtons: ['previous', 'next', 'close'],
      disableActiveInteraction: true,
      onCloseClick: () => {
        this.markHomeTourSeen();
        tour.destroy();
      },
      onDestroyStarted: () => {
        this.markHomeTourSeen();
        tour.destroy();
      }
    });

    tour.setSteps([
      {
        element: '#pnlMenu',
        popover: {
          title: 'Welcome',
          description: 'A quick tour of the main menu and what you can do there.',
          side: 'right',
          align: 'center'
        }
      },
      {
        element: '#tour-nav-startaudit',
        popover: {
          title: this.customerContext.displayText('Start Audit'),
          description: this.customerContext.displayText('Kick off a new audit from your templates.'),
          side: 'right',
          align: 'center'
        }
      },
      {
        element: '#tour-nav-actions',
        popover: {
          title: 'Actions',
          description: 'Track and complete follow-up actions.',
          side: 'right',
          align: 'center'
        }
      },
      {
        element: '#tour-nav-results',
        popover: {
          title: 'View Results',
          description: this.customerContext.displayText('Review completed audits and scores.'),
          side: 'right',
          align: 'center'
        }
      },
      {
        element: '#tour-nav-settings',
        popover: {
          title: 'Settings',
          description: 'Manage locations, users, and configuration.',
          side: 'right',
          align: 'center'
        }
      }
    ]);

    return tour;
  }

  private buildMobileHomeTour(): Driver {
    const tour = driver({
      showProgress: true,
      allowClose: false,
      overlayClickBehavior: 'nextStep',
      showButtons: ['previous', 'next', 'close'],
      disableActiveInteraction: true,
      onCloseClick: () => {
        this.markHomeTourSeen(true);
        this.closeMobileMenu();
        tour.destroy();
      },
      onDestroyStarted: () => {
        this.markHomeTourSeen(true);
        this.closeMobileMenu();
        tour.destroy();
      }
    });

    tour.setSteps([
      {
        element: '#btnMobileMenu',
        popover: {
          title: 'Menu',
          description: 'Tap Next to open the menu.',
          side: 'bottom',
          align: 'start',
          onNextClick: (_element, _step, { driver }) => {
            this.openMobileMenu();
            setTimeout(() => driver.moveNext(), 150);
          }
        }
      },
      {
        element: '#pnlMenu',
        popover: {
          title: 'Main Menu',
          description: 'This is your navigation hub. Here are the key areas.',
          side: 'right',
          align: 'center'
        }
      },
      {
        element: '#tour-nav-startaudit',
        popover: {
          title: this.customerContext.displayText('Start Audit'),
          description: this.customerContext.displayText('Kick off a new audit from your templates.'),
          side: 'right',
          align: 'center'
        }
      },
      {
        element: '#tour-nav-actions',
        popover: {
          title: 'Actions',
          description: 'Track and complete follow-up actions.',
          side: 'right',
          align: 'center'
        }
      },
      {
        element: '#tour-nav-results',
        popover: {
          title: 'View Results',
          description: this.customerContext.displayText('Review completed audits and scores.'),
          side: 'right',
          align: 'center'
        }
      },
      {
        element: '#tour-nav-settings',
        popover: {
          title: 'Settings',
          description: 'Manage locations, users, and configuration.',
          side: 'right',
          align: 'center'
        }
      }
    ]);

    return tour;
  }

  private openMobileMenu() {
    const menuButton = document.querySelector<HTMLElement>('#btnMobileMenu');
    menuButton?.click();
  }

  private closeMobileMenu() {
    const closeButton = document.querySelector<HTMLElement>('#btnCloseMenu');
    closeButton?.click();
  }

  private markHomeTourSeen(isMobile: boolean = false) {
    if (typeof window === 'undefined') {
      return;
    }
    window.localStorage.setItem(isMobile ? this.homeTourSeenMobileKey : this.homeTourSeenKey, 'true');
  }
}
